var _text, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableAddBalanceButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.727,
    height: 16.727,
    viewBox: "0 0 16.727 16.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": " \\u20BA",
    transform: "translate(7.75 12.264)",
    fill: "#199b8b",
    fontSize: 10,
    fontFamily: "Inter-Medium, Inter",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.37,
    y: 0,
    xmlSpace: "preserve"
  }, " \u20BA"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M11.18,0H4.045A3.922,3.922,0,0,0,0,4.252v6.723a3.918,3.918,0,0,0,4.045,4.252H11.18a3.919,3.919,0,0,0,4.047-4.252V4.252A3.919,3.919,0,0,0,11.18,0Z",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAddBalanceButton);
export default __webpack_public_path__ + "static/media/table-add-balance-button.316c9ea17f57dfeeb2b550ae77d833f7.svg";
export { ForwardRef as ReactComponent };